/**
 * Format a value in cents to German currency format.
 * Example: 500000 -> "5.000 €"
 */
export const formatCurrency = (valueInCents: number | string): string => {
  const cents = typeof valueInCents === 'string' ? parseInt(valueInCents, 10) : valueInCents;
  if (isNaN(cents)) return '0 €';
  const euros = cents / 100;
  return `${euros.toLocaleString('de-DE')} €`;
};

/**
 * Format a value in cents the way the drawing overview shows amounts: always
 * two decimals, and the word "Euro" rather than the € sign. This is the form
 * the Scala app used, so the popup reads the same as the old one.
 * Example: 89955750 -> "899.557,50 Euro"
 */
export const formatCurrencyEuro = (valueInCents: number | string): string => {
  const cents = typeof valueInCents === 'string' ? parseInt(valueInCents, 10) : valueInCents;
  const euros = isNaN(cents) ? 0 : cents / 100;
  return `${euros.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Euro`;
};

/**
 * Format a plain count with German thousands separators.
 * Example: 208056 -> "208.056"
 */
export const formatCount = (value: number): string => value.toLocaleString('de-DE', { maximumFractionDigits: 0 });
